import { Spinner, Text } from '@vimeo/bokeh';

import * as finalCopy from '../../../copy/final';
import { LoaderWrapper } from '../ViewerQnA.styles';

export const AiActivationPanel = () => {
  return (
    <LoaderWrapper flexDirection="column" p="16px">
      <Spinner size="xl" variant="basic" />
      <Text
        marginTop="16px"
        fontSize="16px"
        textAlign="center"
        color="text-primary"
        variant="body-xl"
      >
        {finalCopy.aiIsAnalyzing}
      </Text>
    </LoaderWrapper>
  );
};
